import { onApiError } from "../error"
import { state } from "../state"
import { get } from "./client"

/**
 * @param {string} [returnUrl]
 * @returns {Promise<string>}
 */
async function getBillingUrl(returnUrl) {
    const user = await state.getActiveUser()
    let path = `/users/${user.Id}/billing`
    if (returnUrl) path += `?return-url=${encodeURIComponent(returnUrl)}`
    const res = await get(path)

    if (!res.ok) throw await onApiError(res)
    return res.json()
}

export {
    getBillingUrl
}